import { Navigate } from 'react-router-dom';

import { anyPlant, useCan } from '../../../../access';
import { USER_CENTER_RULES } from '../../access';

export const UserCenterIndex = () => {
  const canManagePeople = useCan(USER_CENTER_RULES.manageAccess, anyPlant);
  return <Navigate to={canManagePeople ? 'people' : 'plants'} replace />;
};
